'use client'
import { FC, ChangeEvent, InputHTMLAttributes, ReactNode } from 'react'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import cn from 'classnames'

interface PhoneGeneralInputProps {
  id: string
  type?: InputHTMLAttributes<HTMLInputElement>['type']
  placeholder?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  hasError: boolean
  errorMessage?: ReactNode
  requiredErrorText?: string
  validationPattern: RegExp
  validationErrorText?: string
  register: UseFormRegister<FieldValues>
  onBlur?: () => void
  readOnly?: boolean
}

const PhoneGeneralInput: FC<PhoneGeneralInputProps> = ({
  id,
  type = 'text',
  placeholder,
  onChange,
  hasError = false,
  errorMessage,
  requiredErrorText = 'Required field',
  validationPattern,
  validationErrorText = 'Invalid format',
  register,
  onBlur,
  readOnly,
}) => {
  return (
    <div className="flex w-full flex-col gap-1.5">
      <input
        id={id}
        readOnly={readOnly}
        className={cn(
          'w-full rounded-lg border bg-white px-2.5 py-1.5 text-base leading-none',
          'placeholder:text-neutral-medium-lighter placeholder:font-normal',
          'focus:border-primary-base focus:outline-none',
          hasError ? 'border-error' : 'border-neutral-medium-lighter',
          readOnly && 'bg-neutral-very-light cursor-not-allowed'
        )}
        type={type}
        placeholder={placeholder}
        {...register(id, {
          required: requiredErrorText,
          pattern: {
            value: validationPattern,
            message: validationErrorText,
          },
          onBlur: onBlur,
        })}
        onChange={onChange}
      />
      {hasError && <span className="text-error text-xs">{errorMessage}</span>}
    </div>
  )
}

export default PhoneGeneralInput
